import { getHasMultipleCountries } from "@RequestFormV2/validation/getHasMultipleCountries";

type StopCountryFields = {
  country_name?: string | null;
  port_country?: string | null;
};

function stopHasCountry(stop: StopCountryFields): boolean {
  return Boolean(stop.country_name || stop.port_country);
}

function stopsHaveCountryData(stops: StopCountryFields[] | null | undefined): boolean {
  return Boolean(stops?.some(stopHasCountry));
}

/**
 * Quote Request clearance visibility: multi-stop uses schedule.stops countries
 * (same as RFV2); legacy two-stop forms still use pickup/stop1 (+ port) fields.
 *
 * When stops already carry country data, trust only the stops array so leftover
 * classic pickup/stop1 values cannot keep clearance visible on domestic multi-stop.
 */
export function getHasMultipleCountriesForQuoteRequest({
  stops,
  pickupCountry,
  deliveryCountry,
  pickupPortCountry,
  deliveryPortCountry,
}: {
  stops?: StopCountryFields[] | null;
  pickupCountry?: string | null;
  deliveryCountry?: string | null;
  pickupPortCountry?: string | null;
  deliveryPortCountry?: string | null;
}): boolean {
  if (stopsHaveCountryData(stops)) {
    return getHasMultipleCountries(stops ?? undefined);
  }

  const resolvedPickup = pickupCountry || pickupPortCountry;
  const resolvedDelivery = deliveryCountry || deliveryPortCountry;
  return Boolean(resolvedPickup) && Boolean(resolvedDelivery) && resolvedPickup !== resolvedDelivery;
}
